module.exports = __webpack_public_path__ + "static/media/12UNCTAD3.3c3389df.jpg";